'use client';

import { motion } from 'framer-motion';

type Props = {
  /** Tailwind gradient start color */
  fromClass?: string;
  /** Tailwind gradient end color */
  toClass?: string;
  /** Tailwind width */
  widthClass?: string;
  /** Tailwind height */
  heightClass?: string;
  /** Delay for animation */
  delay?: number;
  /** Absolute position classes (e.g. "top-0 left-0") */
  positionClass?: string;
  /** Rotate if needed (default 90 deg) */
  rotate?: number;
  /** Extra tailwind classes */
  className?: string;
  direction?:
    'left-to-right' | 'right-to-left' | 'top-to-bottom' | 'bottom-to-top';
  distance?: number;
  duration?: number;
};

// interface Props {
//   fromClass?: string;
//   toClass?: string;
//   widthClass?: string;
//   heightClass?: string;
//   delay?: number;
//   positionClass?: string;
//   rotate?: number;
//   className?: string;
//   direction?: 'left-to-right' | 'right-to-left' | 'top-to-bottom' | 'bottom-to-top';
//   distance?: number;

// }

export default function AnimatedLine({
  fromClass = 'from-primary-500',
  toClass = 'to-primary-500/0',
  widthClass = 'w-36',
  heightClass = 'h-0.5',
  delay = 0,
  positionClass = 'top-0 left-0',
  rotate = 0,
  className = '',
  direction = 'left-to-right',
  distance = 180,
}: Readonly<Props>) {
  const isHorizontal =
    direction === 'left-to-right' || direction === 'right-to-left';

  const animateProps =
    direction === 'left-to-right'
      ? { x: [0, distance] }
      : direction === 'right-to-left'
        ? { x: [0, -distance] }
        : direction === 'top-to-bottom'
          ? { y: [0, distance] }
          : { y: [0, -distance] };

  return (
    <motion.div
      initial={{
        opacity: 0,
        x: isHorizontal ? 0 : undefined,
        y: !isHorizontal ? 0 : undefined,
        rotate,
      }}
      animate={{
        opacity: [0, 1, 0],
        ...animateProps,
      }}
      transition={{
        delay,
        duration: 2,
        ease: [0.25, 0.1, 0.25, 1],
        repeat: Infinity,
        repeatDelay: 1.6,
      }}
      className={`pointer-events-none absolute rounded-full bg-linear-to-l will-change-transform ${fromClass} ${toClass} ${widthClass} ${heightClass} ${positionClass} ${className}`}
    />
  );
}
